import React from "react";
import { BaseDialog } from "components/common/Dialogs";
import { Error } from "components/common/ControlElems";
import { getApiErrorMessage } from "context/helpers/contentContextHelper";
import styles from "./ReturningMembers.module.scss";

export default function CancelCampaignDialog({
    processing,
    error,
    onClose,
    onConfirm
}) {
    return (
        <BaseDialog
            id="cancelReturningMemberCampaignDialog"
            label="Cancel Campaign"
            onClose={onClose}
        >
            <div className={styles["send-offer-dialog"]}>
                <p className={styles["send-offer-confirm"]}>
                    Cancel this campaign? Queued emails that are not sent yet
                    will be stopped.
                </p>
                {error && (
                    <Error
                        text={getApiErrorMessage(
                            error,
                            "Failed to cancel the campaign."
                        )}
                    />
                )}
                <div className="d-flex flex-row justify-content-between mt-3">
                    <button
                        type="button"
                        className="btn btn-secondary w-25"
                        onClick={onClose}
                        disabled={processing}
                    >
                        Keep running
                    </button>
                    <button
                        type="button"
                        className="btn btn-danger w-50"
                        onClick={onConfirm}
                        disabled={processing}
                    >
                        {processing ? "Cancelling..." : "Cancel Campaign"}
                    </button>
                </div>
            </div>
        </BaseDialog>
    );
}
